module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAwUlEQVQ4T43SPQ7CMAwF4LyrsbKxMDCxWNkYWBAnYAMxxc0AEmJgR2LpCTgHEgtniFGqtOpPmsazP1l+Npj5LSKl1nqvMqooipWILGCtnTnnngDORLRL2YAuANbwjTm4jYjoXsEpbIxZArj5SR75/gamMDNvReSjtX7UgzpwanJ7/wFs4ReAkojmscCiMARxVUo5AMdY2gPYiRz4jp2qA/uRp3ZuYAylTlXBFBrDyEF9LCInMPMPwKb+iKk/D+95+AMHtrqTwO6hLQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 85